import React, { useEffect, useState } from 'react';
import { Modal, Checkbox, List, Spin, Button, Row, Col, DatePicker, Space, Typography, Radio } from 'antd';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Text } = Typography;

const SyncSkuItemsModal = ({ visible, onOk, onCancel, loading }) => {
  const sellerAccounts = useSelector(state => state.dataCommon.sellerAccounts);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterType, setFilterType] = useState('created'); // 'created' hoặc 'lastUpdated'
  const [createdDateRange, setCreatedDateRange] = useState([]);
  const [lastUpdatedDateRange, setLastUpdatedDateRange] = useState([]);

  useEffect(() => {
    if (visible && sellerAccounts) {
      setSelectedIds(sellerAccounts.map(acc => acc.id)); // Mặc định chọn hết
      setFilterType('created');
      setCreatedDateRange([]); // Reset date range khi mở modal
      setLastUpdatedDateRange([]);
    }
  }, [visible, sellerAccounts]);

  const onChange = (checkedValues) => {
    setSelectedIds(checkedValues);
  };

  const handleFilterTypeChange = (e) => {
    const newFilterType = e.target.value;
    setFilterType(newFilterType);
    
    // Clear opposite filter when switching
    if (newFilterType === 'created') {
      setLastUpdatedDateRange([]);
    } else {
      setCreatedDateRange([]);
    }
  };

  const handleCreatedDateRangeChange = (dates) => {
    setCreatedDateRange(dates);
  };

  const handleLastUpdatedDateRangeChange = (dates) => {
    setLastUpdatedDateRange(dates);
  };

  const handleOk = () => {
    const syncData = {
      selectedIds,
    };

    // Chỉ thêm filter tương ứng với loại đã chọn
    if (filterType === 'created' && createdDateRange && createdDateRange.length === 2) {
      syncData.createdAfter = createdDateRange[0].toISOString();
      syncData.createdBefore = createdDateRange[1].toISOString();
    } else if (filterType === 'lastUpdated' && lastUpdatedDateRange && lastUpdatedDateRange.length === 2) {
      syncData.lastUpdatedAfter = lastUpdatedDateRange[0].toISOString();
      syncData.lastUpdatedBefore = lastUpdatedDateRange[1].toISOString();
    }

    onOk(syncData);
  };

  return (
    <Modal
      title="Select Seller Accounts to sync SKUs from Amazon"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Sync"
      cancelText="Cancel"
      confirmLoading={loading}
      width={600}
    >
      {sellerAccounts.length === 0 ? (
        <Spin />
      ) : (
        <>
          <Space direction="vertical" style={{ width: '100%' }} size="middle">
            {/* Filter Type Selection */}
            <div>
              <Text strong>Time filter type:</Text>
              <br />
              <Radio.Group
                value={filterType}
                onChange={handleFilterTypeChange}
                style={{ marginTop: 8 }}
              >
                <Radio value="created">Filter by SKU creation time</Radio>
                <Radio value="lastUpdated">Filter by SKU last updated time</Radio>
              </Radio.Group>
            </div>

            {/* Date Range Filter */}
            <div>
              <Text strong>
                {filterType === 'created' 
                  ? 'SKU creation time range (optional):' 
                  : 'SKU last updated time range (optional):'}
              </Text>
              <br />
              {filterType === 'created' ? (
                <RangePicker
                  style={{ width: '100%', marginTop: 8 }}
                  placeholder={['From date', 'To date']}
                  value={createdDateRange}
                  onChange={handleCreatedDateRangeChange}
                  showTime={false}
                  format="YYYY-MM-DD"
                />
              ) : (
                <RangePicker
                  style={{ width: '100%', marginTop: 8 }}
                  placeholder={['From date', 'To date']}
                  value={lastUpdatedDateRange}
                  onChange={handleLastUpdatedDateRangeChange}
                  showTime={false}
                  format="YYYY-MM-DD"
                />
              )}
              <Text type="secondary" style={{ fontSize: '12px' }}>
                Leave empty to sync all SKUs
              </Text>
            </div>

            {/* Seller Account Selection */}
            <div>
              <Row gutter={8} style={{ marginBottom: 12 }}>
                <Col>
                  <Button size="small" onClick={() => setSelectedIds(sellerAccounts.map(acc => acc.id))}>
                    Select all
                  </Button>
                </Col>
                <Col>
                  <Button size="small" onClick={() => setSelectedIds([])}>
                    Deselect all
                  </Button>
                </Col>
              </Row>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={selectedIds}
                onChange={onChange}
              >
                <List
                  dataSource={sellerAccounts}
                  renderItem={item => (
                    <List.Item>
                      <Checkbox value={item.id}>{item.name} ({item.sellerId})</Checkbox>
                    </List.Item>
                  )}
                />
              </Checkbox.Group>
            </div>
          </Space>
        </>
      )}
    </Modal>
  );
};

export default SyncSkuItemsModal;
